import * as yup from 'yup';

export const AddDiagnosisSchema = yup.object({
  diagnosis: yup.string().required('Diagnosis is required'),
  icd10Code: yup.string().required('ICD-10 Code is required'),
  status: yup.string().required('Status is required'),
});
